<div class="action-form">
  <span class="title">{{ 'BUILDING_FORM.MOVE_TO_PROPERTY_HEADER' | translate }}</span>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row form-group">
        <div class="col-12">
          <app-autocomplete-remote-paged
            [control]="form.controls['destinationPropertyId']"
            [service]="propertyService"
            [defaultSearch]="'*'"
          ></app-autocomplete-remote-paged>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button class="btn btn-active" type="submit">{{ 'SAVE_BTN' | translate }}</button>
          <button class="btn link-btn ml-2" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
        </div>
      </div>
    </form>
  }
</div>
